import { useState } from "react";

import { useAuth } from "context/AuthContext";
import { useNavigate } from "react-router-dom";

import { AiOutlineLock, AiOutlineUser } from "react-icons/ai";
import { Oval } from "react-loader-spinner";

export const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  let navigate = useNavigate();
  const { login } = useAuth();

  const handleSignIn = async () => {
    setLoading(true);
    const result = await login(email, password);
    if (result) {
      navigate("/");
      setLoading(false);
    }
  };
  return (
    <div className="w-full h-screen flex flex-1 flex-col px-5 items-center justify-center text-slate-300 bg-gray-800">
      <div className="grid grid-rows-1 md:grid-cols-2 w-full max-w-[800px] bg-gray-700 rounded-lg overflow-hidden shadow-xl">
        <div className="flex flex-col space-y-5 p-10 order-1 md:order-none">
          <h1 className="md:text-5xl text-4xl font-bold">Login</h1>

          <h2 className="md:text-xl text-lg">Sign In with your credentials</h2>

          <div className="relative flex  bg-gray-800  rounded-lg h-10   overflow-hidden shadow-xl">
            <div className="bg-gray-500/80 px-3 flex justify-center items-center">
              <AiOutlineUser className="w-5 h-5  " />
            </div>
            <input
              placeholder="Username"
              type={"email"}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              className=" bg-transparent focus:border rounded-r-lg outline-dashed focus:border-primary  outline-none px-2  w-full "
            />
          </div>

          <div className="relative flex  bg-gray-800  rounded-lg h-10   overflow-hidden shadow-xl">
            <div className="bg-gray-500/80 px-3 flex justify-center items-center">
              <AiOutlineLock className="w-5 h-5  " />
            </div>
            <input
              type={"password"}
              placeholder="Password"
              onChange={(e) => {
                setPassword(e.target.value);
              }}
              className=" bg-transparent focus:border rounded-r-lg outline-dashed focus:border-primary  outline-none px-2  w-full "
            />
          </div>
          <div className="flex md:justify-between justify-center items-center">
            <button
              className="bg-blue-500  text-slate-300 w-fit py-3 px-10 rounded-lg hover:bg-blue-700 shadow-lg transition-all duration-300 ease-out"
              onClick={handleSignIn}
            >
              Login
            </button>
            {loading && (
              <Oval
                height={40}
                width={40}
                color="royalblue"
                secondaryColor="white"
              />
            )}
          </div>
        </div>
        <div className="flex flex-col space-y-6 bg-gray-900/30 items-center justify-center p-5">
          <img src={"/Logo.png"} className="md:w-1/3 w-1/3" alt="Logo" />
          <div className="flex flex-col justify-center items-center space-y-2">
            <h1 className="text-2xl font-bold">KAUST GUARDIAN</h1>
            <h2 className="text-xl">U I S Department</h2>
          </div>
        </div>
      </div>
      <p className="text-sm absolute bottom-2 md:bottom-5">
        Designed & Built by <span className="text-purple-500">Rana Bojan</span>
      </p>
    </div>
  );
};

export default Login;
